import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

const DATA_ANALYTICS_HEADER_HEIGHT = 200;

export const StyledContainer = styled(Box)`
  padding: 1.5rem;
  overflow: hidden;
  height: calc(100vh - ${DATA_ANALYTICS_HEADER_HEIGHT}px);
`;

export const StyledSelectContainer = styled(Box)`
  width: 230px;
`;

export const StyledSpinnerWrapper = styled(FlexCenter)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
